import { useContext } from 'react';
import { WishlistContext } from '@/components/context/WishlistContext/WishlistContext';

/**
 * Returns Wishlist along with actions to interact with the wishlist
 */
export const useWishlist = () => {
  const context = useContext(WishlistContext);

  return context;
};
